import { Account } from "@dreamhub/designsystem/icons";
import PageLayout from "@/pages/settings/components/PageLayout";
import { FieldManagementTab } from "@/pages/settings/components/dealsSettings/FieldManagement/FieldManagementTab";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CompaniesSettingsTabs } from "@/pages/settings/types";
import { useSearchParams } from "react-router-dom";
import { EntityType } from "@/services/hooks/entities/useEntityType";

const TRANSLATION_KEY = "settings.companies";
const TRANSLATION_KEY_TABS = "settings.companies.tabs";

export const CompaniesSettings = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [tabValue, setTabValue] = useState<CompaniesSettingsTabs>(() => {
    const tabParam = searchParams.get("tab");
    return Object.values(CompaniesSettingsTabs).includes(
      tabParam as CompaniesSettingsTabs
    )
      ? (tabParam as CompaniesSettingsTabs)
      : CompaniesSettingsTabs.FIELD_MANAGEMENT;
  });

  useEffect(() => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", tabValue);
      return params;
    });
  }, [tabValue, setSearchParams]);

  const getTabOptions = () => {
    const options: Record<string, string> = {};
    Object.values(CompaniesSettingsTabs).forEach((tab) => {
      options[tab] = t(`${TRANSLATION_KEY_TABS}.${tab}`);
    });

    return options;
  };

  const onTabChange = (newTabValue: string) => {
    setTabValue(newTabValue as CompaniesSettingsTabs);
  };

  const renderTabContent = () => {
    switch (tabValue) {
      case CompaniesSettingsTabs.FIELD_MANAGEMENT:
        return <FieldManagementTab entityType={EntityType.COMPANY} />;
      default:
        return <FieldManagementTab entityType={EntityType.COMPANY} />;
    }
  };

  return (
    <PageLayout
      data-test="settings-companies-page"
      title={t(`${TRANSLATION_KEY}.title`)}
      logoIcon={<Account />}
      tabs={{
        options: getTabOptions(),
        defaultValue: tabValue,
        valueSelected: onTabChange
      }}
    >
      {renderTabContent()}
    </PageLayout>
  );
};
